import React from 'react';
import { Route } from 'react-router-dom';
import IDTypeList from './views/containers/IDListView'
import IDTypeDetail from './views/containers/IDDetailView'
import MemberTypeList from './views/containers/MemberTypeListView'
import MemberTypeDetail from './views/containers/MemberTypeDetailView'
import LoanTypeList from './views/containers/LoanTypeListView'
import LoanTypeDetail from './views/containers/LoanTypeDetailView'
import NonWorkingDayList from './views/containers/NonWorkingDayListView'
import NonWorkingDayDetail from './views/containers/NonWorkingDayDetailView'
import MemberList from './views/containers/MemberListView'
import MemberDetail from './views/containers/MemberDetailView'
import AccountDepositView from './views/containers/AccountDepositView'
import AccountWithdrawView from './views/containers/AccountWithdrawView'
import LoanApplicationForm from './views/components/LoanApplicationForm'
import  LoanCalculator from './views/components/LoanCalculator'
import  LoanApplicationsList from './views/containers/LoanApplicationListView'
import  LoanApplicationDetail from './views/containers/LoanApplicationDetailView'
import  LoanAssessmentForm from './views/components/LoanAssessmentForm'
import  LoanAssessmentList from './views/containers/LoanAssessmentListView'
import  LoanAppovalForm from './views/components/LoanApprovalForm'
import  LoanApprovalList from './views/containers/LoanApprovalListView'
import  LoanIssuanceForm from './views/components/LoanIssuanceForm'
import  LoanIssuanceList from './views/containers/LoanIssuancesListView'
import  LoanIssueDetail from './views/containers/LoanIssueDetails'
import  LoanRepaymentView from './views/containers/LoanRepaymentView'
import LoanGuarantorsList from './views/containers/LoanGuarantorsListView'
import LoanConsentsList from './views/containers/LoanConsentsListView'
import OpeningItemList from './views/containers/AccountOpeningItemsListView'
import TillSheetReport from './views/containers/TillSheetReportView'
import MemberSummaryReport from './views/containers/MemberSummaryReport'
import IncomeStatementReport from './views/containers/IncomeStatementView'
import DayLoanReport from './views/containers/DayLoanReportView'
import OutStandingLoanReport from './views/containers/OutStandingLoanReportView'
import LoanRepaymentStatusReport from './views/containers/LoanRepaymentStatusReportView'
import LoanDefaultsReport from './views/containers/LoanDefaultsReportView'
import LoanAgingReport from './views/containers/LoanAgingReportView'
import LoanDisbursmentReport from './views/containers/LoanDisbursmentReportView'
import LoanRepaymentsReport from './views/containers/LoanRepaymentsReportView'
import BalanceSheetReport from './views/containers/BalanceSheetView'
import Bl_SheetView from './views/containers/Bl_SheetView';
import ShareTransferView from './views/containers/ShareTransferView'
import SubAccountTransferView from './views/containers/SubAccountTransferView'
import FinancialStatementReport from './views/containers/FinancialStatementReportView'
import AccountList from './views/containers/AccountsListView'
import AccountDetail from './views/containers/AccountDetailView'
import SendSMSMessageView from './views/containers/SendSMSMessageView'
import GroupList from './views/containers/GroupsListView'
import GroupDetail from './views/containers/GroupDetailView'
import LoggedInList from './views/containers/LoggedInAccountsListView'

import SaccoMembersPerUserReport from './views/containers/SaccoMembersPerUserReportView'
import SaccoSmsUsagestatementreport from './views/containers/saccosmsusagestatementreport'


import  LoanDailyRepaymentView from './views/containers/LoanDailyRepaymentView'


import IncomeStatementsDividendsReport from './views/containers/IncomeStatementDividendsView'

import  LoanRepaymentDirectView from './views/containers/LoanRepaymentDirectView'
import  PeriodicMemberSummaryReport from './views/containers/PeriodicMemberSummaryReportView'
import CompanyAccountList from './views/containers/CompanyAccountsListView'
import TrialBalanceReport from './views/containers/TrialBalanceView'
import LedgerReport from './views/containers/LedgerReportView'

import DashBoard from './views/containers/DashBoard'
import QuickMenu from './views/containers/QuickMenu'

import LoanFinesReport from './views/containers/LoanFinesReportView'

import  LoanSecurityTransferView from './views/containers/LoanSecurityTransferView'
import SaccoInterAccountTransfer from './views/containers/SaccoInterAccountsTransferView'
import PeriodicPerformanceSummaryReport from './views/containers/PeriodicPerformanceSummaryReport'
import  LoanRejectionList from './views/containers/LoanRejectionListView'

import  SystemLogList from './views/containers/SystemLogsListView'
import  InterAccountTransfersSingle from './views/containers/InterAccountTransferSingleView'
import DistrictList from './views/containers/UgDistrictListView'
import UgDistrictDetail from './views/containers/UgDistrictDetailView'

import SendButchEMailStatementView from './views/containers/SendButchEmailStatementView'
import emailsentReport from './views/containers/emailsentreport'
import ChartOfAccounts from './views/containers/ChartOfAccountsView'
import  UserSaccoAccountList from './views/containers/UserSaccoAccountAttachmentListView'

import FixedDepositLists from './views/containers/FixedDepositListView'
import FixedDepositDetails from './views/containers/FixedDepositDetailsView'
import SalaryRequistionView from './views/containers/SalaryRequistionView'
import SalaryRequistionList from './views/containers/salaryrequisitionListView'
import CompanyProfile from './views/containers/companyProfile'

import SavingsInterestPayOffForm from './views/components/SavingsInterestPayOffForm'
import OnboardingSectionView from './views/containers/OnboardingSectionView'
import InterAccountTransfers from './views/containers/InterAccountTransferView'
import MobileMoneycollectionlist from './views/containers/MobileMoneycollectionlist'
import MemberAutoPaymentsReport from './views/containers/MemberAutoPaymentsReportView'
import TransactionsReset from './views/components/TransactionsResetForm'
import JournalEntryView from './views/containers/JournalEntryView'

import MemberPaymentsEntryView from './views/containers/MemberPaymentsEntryView'
import  QuickTransact from './views/containers/QuickTransact'
import  CumDividenttoSavingsTransferView from './views/containers/CumDividenttoSavingsTransferView'
import  CashFlowReport from './views/containers/CashFlowReportView'
import  VouchersList from './views/containers/VouchersListView'
import  TargetList from './views/containers/TargetsListView'
import  LoanConsolidationForm from './views/containers/LoanConsolidationForm'
import FinancialStatementsView from './views/containers/FinancialStatementsView_fr1';

import DataUploadForm_Json from './views/components/DataUploadForm_Json';
import DataUploadForm_LoanOpeningBal from './views/components/DataUploadForm_LoanOpeningBal';

import JournalEntryAccountChangeForm from './views/containers/JournalEntryAccountChangeForm';
import ReserveReportView from './views/containers/ReserveReportView';



const SaccoBaseRouter = () =>(
    <div>
        <Route exact path='/' component={QuickMenu}  />
        <Route exact path='/quickmenu/' component={QuickMenu}  />
        
        <Route exact path='/idtypes/' component={IDTypeList}  />

        <Route exact path='/idtypes/:idtypeID' component={IDTypeDetail} />
        <Route exact path='/membertypes/' component={MemberTypeList}  />
        <Route exact path='/membertypes/:membertypeID' component={MemberTypeDetail}  />
        <Route exact path='/loantypes/' component={LoanTypeList}  />
        <Route exact path='/loantypes/:loanTypeID' component={LoanTypeDetail}  />
        <Route exact path='/nonworkingdays/' component={NonWorkingDayList}  />
        <Route exact path='/nonworkingdays/:dayID' component={NonWorkingDayDetail}  />
        <Route exact path='/members/' component={MemberList}  />
        <Route exact path='/members/:memberID' component={MemberDetail}  />
        <Route exact path='/deposit/' component={AccountDepositView}  />
        <Route exact path='/withdraw/' component={AccountWithdrawView}  />
        <Route exact path='/loanapplication/' component={LoanApplicationForm}  />
        <Route exact path='/loancalculator/' component={LoanCalculator}  />
        <Route exact path='/loanapplications/' component={LoanApplicationsList}  />
        <Route exact path='/loanapplications/:loanapplicationID' component={LoanApplicationDetail}  />
        <Route exact path='/makeassessment/:loanapplicationID' component={LoanAssessmentForm}  />
        <Route exact path='/loanassessments/' component={LoanAssessmentList}  />
        <Route exact path='/approveloan/:loanapplicationID' component={LoanAppovalForm}  />
        <Route exact path='/loanapprovals/' component={LoanApprovalList}  />
        <Route exact path='/issueloan/:loanapplicationID' component={LoanIssuanceForm}  />
        <Route exact path='/loanissues/' component={LoanIssuanceList}  />
        <Route exact path='/loanissues/:loanissueID' component={LoanIssueDetail}  />
        <Route exact path='/loanrepayment/' component={LoanRepaymentView}  />
        <Route exact path='/loanguarantors/:applicationID' component={LoanGuarantorsList}  />
        <Route exact path='/loanconsents/:applicationID' component={LoanConsentsList}  />
        <Route exact path='/accountopeningitems/:accountTypeID' component={OpeningItemList}  />
        <Route exact path='/tillsheet/' component={TillSheetReport}  />
        <Route exact path='/memberbalances/' component={MemberSummaryReport} />
        <Route exact path='/incomestatement/' component={IncomeStatementReport} />
        <Route exact path='/dayloanreport/' component={DayLoanReport} />
        <Route exact path='/loanoutstanding/' component={OutStandingLoanReport} />
        <Route exact path='/loanrepaymentstatus/' component={LoanRepaymentStatusReport} />
        <Route exact path='/loandefaults/' component={LoanDefaultsReport} />
        <Route exact path='/loanaging/' component={LoanAgingReport} />
        <Route exact path='/loandisbursement/' component={LoanDisbursmentReport} />
        <Route exact path='/loanrepaymentreport/' component={LoanRepaymentsReport} />
        <Route exact path='/balancesheet/' component={Bl_SheetView} />
        <Route exact path='/sharetransfer/' component={ShareTransferView} />
        <Route exact path='/subaccounttransfer/' component={SubAccountTransferView} />
        <Route exact path='/financialstatement/' component={FinancialStatementReport} />
        <Route exact path='/useraccounts/' component={AccountList} />
        <Route exact path='/useraccounts/:accountID' component={AccountDetail} />
        <Route exact path='/messaging/' component={SendSMSMessageView} />
        <Route exact path='/groups/' component={GroupList} />
        <Route exact path='/groups/:groupID' component={GroupDetail}  />
        <Route exact path='/loggedinusers/' component={LoggedInList} />

        <Route exact path='/memberperuserreport/' component={SaccoMembersPerUserReport} />
        <Route exact path='/saccosmsusagestatement/' component={SaccoSmsUsagestatementreport} />
        <Route exact path='/loandailyrepayment/' component={LoanDailyRepaymentView}  />
        <Route exact path='/dividendscalculator/' component={IncomeStatementsDividendsReport}  />
        <Route exact path='/loanrepaymentdirect/' component={LoanRepaymentDirectView}  />

        <Route exact path='/periodicmember_summaryreport/' component={PeriodicMemberSummaryReport}  />
        <Route exact path='/companyaccounts/' component={CompanyAccountList}  />
        <Route exact path='/trialbalance/' component={TrialBalanceReport}  />
        <Route exact path='/ledgerreport/' component={LedgerReport}  />

        <Route exact path='/loanfines/' component={LoanFinesReport} />
        <Route exact path='/ugdistricts/' component={DistrictList}  />
        <Route exact path='/ugdistricts/:districtID' component={UgDistrictDetail}  />
        
        <Route exact path='/loansecuritytransfer/' component={LoanSecurityTransferView}  />
        <Route exact path='/org_interaccount_transfer/' component={SaccoInterAccountTransfer}  />
        <Route exact path='/periodic_performance_report/' component={PeriodicPerformanceSummaryReport}  />
        <Route exact path='/rejectedloanapplications/' component={LoanRejectionList}  />
        <Route exact path='/systemlogs/' component={SystemLogList}  />
        <Route exact path='/interaccounttransfer/' component={InterAccountTransfersSingle}  />

        <Route exact path='/batchemail_statementsending/' component={SendButchEMailStatementView}  />
        <Route exact path='/sentemailsreport/' component={emailsentReport}  />
        <Route exact path='/chartof_accounts/' component={ChartOfAccounts}  />
        <Route exact path='/user_saccoaccounts/:accountID' component={UserSaccoAccountList}  />

        <Route exact path='/fixeddeposits/' component={FixedDepositLists}  />
        <Route exact path='/fixeddeposits/:depositid' component={FixedDepositDetails}  />

        <Route exact path='/salaryrequisition/' component={SalaryRequistionView}  />
        <Route exact path='/salaryrequisitionlist/' component={SalaryRequistionList} />
        <Route exact path='/companyprofile/' component={CompanyProfile} />
        <Route exact path='/savingsinterestpayoff/' component={SavingsInterestPayOffForm} />

        <Route exact path='/dataonboarding/' component={OnboardingSectionView} />
        <Route exact path='/dataonboarding_json/' component={DataUploadForm_Json} />

        <Route exact path='/inter_account_tranfer_betweenmembers/' component={InterAccountTransfers} />

        <Route exact path='/mobilemoneycollections/' component={MobileMoneycollectionlist} />
        <Route exact path='/member_autopaymentsreport/' component={MemberAutoPaymentsReport} />
        <Route exact path='/transactions_reset/' component={TransactionsReset} />
        <Route exact path='/multijournal/' component={JournalEntryView} />
        <Route exact path='/member_payments/' component={MemberPaymentsEntryView} />
        <Route exact path='/quicktransact/' component={QuickTransact}  />

        <Route exact path='/cumulativedividends_tosavings/' component={CumDividenttoSavingsTransferView} />
        <Route exact path='/cashflow_report/' component={CashFlowReport} />
        <Route exact path='/vouchers_list/' component={VouchersList} />
        <Route exact path='/user_targets/' component={TargetList} />
        <Route exact path='/loan_consolidation/' component={LoanConsolidationForm} />
        <Route exact path='/financial_statements/' component={FinancialStatementsView} />
        <Route exact path='/update_journals_account/' component={JournalEntryAccountChangeForm} />

        <Route exact path='/loanopening_balances_upload/' component={DataUploadForm_LoanOpeningBal} />
        <Route exact path='/reserve_report/' component={ReserveReportView} />
        <Route exact path='/statistics/' component={DashBoard} />


    </div>
);

export default SaccoBaseRouter;


